import { createApi } from '@reduxjs/toolkit/query/react'
import customFetchBase from '../services/CustomFetchBase'

/**
 * API slice for managing user details.
 */
export const userDetailsApi = createApi({
    reducerPath: 'userDetailsApi',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        /**
         * Query to fetch user details.
         *
         * @returns {Promise<any>} The response containing user details.
         */
        getUserDetails: builder.query({
            query: () => ({
                url: '/getUserDetails',
                method: 'GET'
            })
        }),

        /**
         * Mutation to update the user's student status.
         *
         * @param {boolean} isStudent - Indicates whether the user is a student.
         * @returns {Promise<any>} The response after updating the student status.
         */
        updateIsStudent: builder.mutation({
            query: (isStudent: boolean) => ({
                url: '/updateUserProfile',
                method: 'PUT',
                body: { isStudent }
            })
        })
    })
})

/**
 * Auto-generated hooks for user details API.
 */
export const { useGetUserDetailsQuery, useUpdateIsStudentMutation } = userDetailsApi
